import { Fragment, ReactNode } from 'react';

import { Link } from 'react-router-dom';

import SkillCard from '../../components/molecules/skill-card/SkillCard';
import SkillData from '../../types/skillData';

import './SkillCardRow.scss';
import clsx from 'clsx';

export interface SkillCardRowProps {
  skills: SkillData[];
  headline: string;
  subheadline?: string;
  admin?: boolean;
  completed?: boolean;
  onDelete?: (skill: SkillData) => void;
  onTogglePublish?: (skill: SkillData) => void;
  className?: string;
  children?: ReactNode;
  cardSize?: 'xs' | 'sm' | 'md';
}

export default function SkillCardRow({
  skills,
  headline,
  subheadline = '',
  admin = false,
  completed = false,
  onDelete = () => {},
  onTogglePublish = () => {},
  className = '',
  cardSize = 'md',
  children,
}: SkillCardRowProps) {
  const SkillCards = skills.map(skill => {
    return (
      <Fragment key={skill.id}>
        <li>
          {admin ? ( // An admin-view skill card can not be entirely wrapped in a link since it has nested links in content. It will however be linked around it's image
            <SkillCard skill={skill} showAdminView onDelete={onDelete} onTogglePublish={onTogglePublish} />
          ) : completed ? (
            <Link to={`/skills/${skill.slug}`}>
              <SkillCard skill={skill} completed />
            </Link>
          ) : (
            <SkillCard skill={skill} animated onDelete={onDelete} onTogglePublish={onTogglePublish} />
          )}
        </li>
      </Fragment>
    );
  });

  return (
    <div className={className}>
      <h2 className="strong-heading">{headline}</h2>
      <h2 className="strong-heading-mb">{subheadline}</h2>
      <ol className={clsx('skill-card-row', cardSize)}>
        {SkillCards}
        {children}
      </ol>
    </div>
  );
}
